import { render, staticRenderFns } from "./dzbdetail.vue?vue&type=template&id=2df9195f&scoped=true&"
import script from "./dzbdetail.vue?vue&type=script&lang=js&"
export * from "./dzbdetail.vue?vue&type=script&lang=js&"
import style0 from "./dzbdetail.vue?vue&type=style&index=0&id=2df9195f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df9195f",
  null
  
)

export default component.exports